export const FETCH_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES = {
  START: 'START_FETCH_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES',
  COMPLETE: 'COMPLETE_FETCH_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES',
  FAIL: 'FAIL_FETCH_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES',
  CLEANUP: 'CLEANUP_FETCH_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES',
}

export const SAVE_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES = {
  START: 'START_SAVE_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES',
  COMPLETE: 'COMPLETE_SAVE_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES',
  FAIL: 'FAIL_SAVE_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES',
}
